
export enum FileType {
    ApplicationXHtmlFragment = 'application/x-html-fragment',
    Document = 'document',
    HtmlFragment = 'html-fragment',
    HtmlPage = 'html-page',
    Image = 'image',
    Pdf = 'pdf',
    Presentation = 'presentation',
    Unknown = 'unknown'
}

export enum RichContentMimeType {
    ApplicationXAnnouncement = 'application/x-announcement',
    ApplicationXAssignment = 'application/x-assignment',
    ApplicationXBook = 'application/x-book',
    ApplicationXBookChapter = 'application/x-book-chapter',
    ApplicationXDiscussionTopic = 'application/x-discussion-topic',
    ApplicationXDocument = 'application/x-document',
    ApplicationXFile = 'application/x-file',
    ApplicationXFolder = 'application/x-folder',
    ApplicationXForum = 'application/x-forum',
    ApplicationXGlossary = 'application/x-glossary',
    ApplicationXGlossaryEntry = 'application/x-glossary-entry',
    ApplicationXHtmlBlock = 'application/x-html-block',
    ApplicationXLabel = 'application/x-label',
    ApplicationXItem = 'application/x-item',
    ApplicationXLearningModule = 'application/x-learning-module',
    ApplicationXLesson = 'application/x-lesson',
    ApplicationXLessonDescription = 'application/x-lesson-description',
    ApplicationXLessonPage = 'application/x-lesson-page',
    ApplicationXLinkDiscussionTopic = 'application/x-link-discussion-topic',
    ApplicationXLinkWeb = 'application/x-link-web',
    ApplicationXLtiLaunch = 'application/x-lti-launch',
    ApplicationXModule = 'application/x-module',
    ApplicationXPage = 'application/x-page',
    ApplicationXPageContent = 'application/x-page-content',
    ApplicationXPageIntro = 'application/x-page-intro',
    ApplicationXSection = 'application/x-section',
    ApplicationXQuiz = 'application/x-quiz',
    ApplicationXSyllabus = 'application/x-syllabus'
}
